import { render, staticRenderFns } from "./TypeContracts.vue?vue&type=template&id=218dad16"
import script from "./TypeContracts.vue?vue&type=script&lang=js"
export * from "./TypeContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports